import React from 'react';
import { PropTypes } from 'prop-types';

import HeroCarouselSlide from '@atoms/HeroCarouselSlide/index';
import Button from '@atoms/Button';
import HeroCarousel from '@molecules/HeroCarousel/index';
import LoadingArea from '@molecules/LoadingArea';
import { redirectToUrl } from '@general/helpers/links.helpers';
import useCarousel from '../../../hooks/useCarousel';

const MyIcscCarousel = ({ section }) => {
    const { isLoading, data } = useCarousel(section);

    const getSlideRender = () => {
        if (!data) return;
        return data.map((slide, i) => (
            <HeroCarouselSlide
                key={i}
                imageUrl={slide.background_image}
                contentBlock={
                    <>
                        <div className="mb-4 text-center light">
                            <h2>{slide.title}</h2>
                        </div>
                        {slide.button_text && (
                            <Button onClick={() => redirectToUrl(slide.link)} buttonClasses="px-6">
                                {slide.button_text}
                            </Button>
                        )}
                    </>
                }
            />
        ));
    };

    const slideItems = getSlideRender();

    return (
        <>
            {isLoading && <LoadingArea minHeight={200} />}
            {!isLoading && <HeroCarousel>{slideItems}</HeroCarousel>}
        </>
    );
};

MyIcscCarousel.propTypes = {
    section: PropTypes.string,
};

// TODO: determine size of carousel slides - maybe make this into it's own component
const styles = {
    container: {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        left: 0,
        minHeight: 200,
        textAlign: 'center',
        top: 0,
        width: '100%',
        zIndex: 99999,
    },
    content: {
        background: '#ffffff url("/assets/images/loading.gif") no-repeat center center',
        backgroundSize: '100% 100%',
        border: '1px solid #888',
        borderRadius: '5px',
        height: '50px',
        padding: '10px',
        width: '50px',
    },
};

export default MyIcscCarousel;
